// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* analytics overview styling */

.MuiTabPanel-root {
  padding: 32px 0px 0px 0px !important;
}

.overviewMainDiv {
  /* width: 1124px; */
  width: 100%;
  background: #fff;
}

.mainDivOfAnalytics {
  display: flex;
  /* margin-bottom: 15px; */
}

.contentStyling {
  /* height: 74px; */
  /* width: 198px; */
  width: 80%;
  margin-right: 60px;
}

.totalPaymentHeading.MuiTypography-root {
  color: var(--text-high, rgba(1, 1, 2, 0.72));
}

.amountHeading.MuiTypography-root {
  color: #0e0f0f;
}

.increaseLogo {
  margin-left: 5px;
  height: 24px;
  width: 24px;
}

.increaseText.MuiTypography-root {
  color: var(--comms-positive, #0b6a48);
}

.decreaseText.MuiTypography-root {
  color: var(--comms-negative, #b9232f);
}

.dropdownDiv {
  float: right;
  /* margin-top: 8px; */
  /* margin-right: 20px; */
  display: flex;
  align-items: center;
}

/* .MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root{
  height: 32px !important;
} */

.monthDropdown {
  width: auto;
  height: 28px;
  flex-shrink: 0;
  align-items: left;
  gap: 16px;
}

.monthDropdown.MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  /* Body 11 Medium */
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  /* 127.273% */
}

.downloadIcon {
  margin-left: 6px;
  width: 24px;
  height: 24px;
}

.dividerBeforeTicket {
  /* width: 1060px; */
  height: 1px;
  padding-top: 10px;
}

.ticketDiv {
  width: 212px;
  height: 107px;
  padding: 17px 12px;
  margin-right: 18px;
  border-radius: 12px;
  margin-top: 8px;
  border: 1px solid #e1e1e1;
  margin-bottom: 18px;
}

.ticketSizeText.MuiTypography-root {
  margin-top: 15px;
  color: var(--text-high, rgba(1, 1, 2, 0.72));
}

.ticketAmout.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  margin-bottom: 9px;
}

.ticketCount.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
}

.countBorder {
  border: 1px solid var(--text-highest, rgba(1, 1, 2, 0.92));
  border-radius: 50%;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  padding-left: 4px;
  margin-right: 9px;
}

.ticketTransaction.MuiTypography-root {
  color: rgba(1, 1, 2, 0.6);

  margin-bottom: 4px;
}

.ticketValue {
  color: rgba(1, 1, 2, 0.72);
  font-weight: 700;
}

/* graph divs */

.graphyDiv {
  width: 70%;
  height: 300px;
}

.paymentDiv {
  height: 412px;
  flex-shrink: 0;
  border-radius: 16px;
  background: white !important;
  padding: 16px;
}

.paymentHeading.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  margin-bottom: 12px;
}

.payemntDataDiv {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  height: 26px;
}

.paymentDivider {
  width: relative;
  height: 1px;
  background: rgba(1, 1, 2, 0.12);
}

.paymentText.MuiTypography-root {
  color: #0e0f0f;
  margin-bottom: 12px;
}

.paymentLogo {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

/* payment dropof */

.paymentOfDiv {
  width: 100%;
  margin-top: 40px;
  display: flex;
  border-radius: 16px;
  background: var(--primary-accent-sub-2, #f0f5ff);
}

.countDiv {
  width: 50%;
  padding-right: 20px;
}

.countHeadingDiv {
  text-align: center;
  margin-bottom: 30px;
}

.countHeading.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
}

.countTransactionDiv {
  display: flex;
  flex-direction: column;
  float: left;
  width: 50%;
  margin-bottom: 16px;
}

.percentageDiv {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 16px;
}

.barColorDiv {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.paddingEight {
  padding-top: 8px;
  padding-left: 8px;
}

.divWithLessOnePercentageWidth {
  /* color: white; */
  height: 36px;
  /* margin-right: 8px; */
}

.countHeading.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
}

.countAmountHeading.MuiTypography-root {
  color: var(--text-high, rgba(1, 1, 2, 0.72));
}

.totalDiv {
  width: 50%;
  padding-left: 20px;
}

/* failure reasons */

.marginTop20 {
  margin-top: 20px;
}

.reasonCodeDistributionMainDiv {
  display: flex;
  margin-top: 28px;
  justify-content: center;
}

.reasonCodeDistributionDiv {
  width: 60%;
  height: 396px;
}

.reasonUpperDiv {
  display: flex;
  height: 96px;
  padding: 24px 24px 16px 24px;
  justify-content: space-between;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  gap: 24px;
  background-color: white;
}

.reasonLowerDiv {
  width: 100%;
  /* display: flex; */
  padding: 20px 24px;
  /* justify-content: center;
  align-items: center; */
  background-color: white;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  height: 300px;
  overflow-y: scroll;
  max-height: 300px;
}

.reasonLeftDiv {
  width: 50%;
  margin-bottom: 14px;

  display: flex;
  /* justify-content: end; */
  padding-right: 50px;
}

.reasonRightDiv {
  display: flex;
  width: 50%;
  text-align: center;
  margin-bottom: 14px;
  font-weight: 600;
  font-size: 16px;
}

.marginTopAndLeft.MuiTypography-root {
  margin-left: 16px;
  margin-top: 5px;
}

.analyticsTableDivInFailure {
  width: 40%;
  height: 396px;
  background-color: white;
  border-radius: 12px;
  margin-left: 23px;
}

.paymentOfAndFailureDiv {
  width: 100%;
  /* height: 674px; */
  margin-top: 32px;
  padding: 32px;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--primary-accent-sub-2, #f0f5ff);
}

.downloadIconPosition {
  cursor: pointer;
  float: right;
}

.failurePaper.MuiPaper-root {
  border-radius: 16px;
  /* background: ; */
  /* width: 673px; */
  width: 50%;
  height: 466px;
  flex-shrink: 0;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 20px;
  padding: 24px;
}

.refreshButton.MuiButtonBase-root.MuiButton-root {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  text-transform: none;
  width: 100px;
  height: 32px;
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-1, #fff);
  padding: 10px;
  margin-right: 12px;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
}

.refreshButton:hover {
  border-color: var(--your-hover-color, black) !important;
}

.custom-dropdown-icon {
  color: rgba(0, 0, 0, 0.85) !important;
  /* Set your desired color */
}

.MuiButtonBase-root.MuiMenuItem-root:hover {
  background-color: #F3F4F4;
}

.MuiButtonBase-root.MuiMenuItem-root {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.businessUnit.MuiButtonBase-root.MuiMenuItem-root {
  padding-left: 0px;
  padding-right: 0px;
}

.itemNameStyling {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.businessUnitCheckbox .MuiSvgIcon-root {
  height: 16px !important;
  width: 16px !important;
}

.ellipsisListItem .MuiListItemText-root .MuiTypography-root {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellipsisListItemInsurer .MuiListItemText-root .MuiTypography-root {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {
  /* background-color: #F3F4F4; */
}

.overview-analytics-root {
  width: 100%;
  background: #fff;
}

.overview-analytics-contnet {
  display: grid;
  grid-template-columns: calc(55% - 28px) 45%;
  column-gap: 24px;
  row-gap: 28px;
  margin-top: 28px;
}

.overview-analytics-contnet>div:first-child {
  grid-column: 1 / span 2;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/analytics/overview/overview.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,6CAA6C;;EAE7C,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;;EAE/C,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;;EAEzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,6CAA6C;;EAE7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;wBACsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;;EAEnB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* analytics overview styling */\n\n.MuiTabPanel-root {\n  padding: 32px 0px 0px 0px !important;\n}\n\n.overviewMainDiv {\n  /* width: 1124px; */\n  width: 100%;\n  background: #fff;\n}\n\n.mainDivOfAnalytics {\n  display: flex;\n  /* margin-bottom: 15px; */\n}\n\n.contentStyling {\n  /* height: 74px; */\n  /* width: 198px; */\n  width: 80%;\n  margin-right: 60px;\n}\n\n.totalPaymentHeading.MuiTypography-root {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n}\n\n.amountHeading.MuiTypography-root {\n  color: #0e0f0f;\n}\n\n.increaseLogo {\n  margin-left: 5px;\n  height: 24px;\n  width: 24px;\n}\n\n.increaseText.MuiTypography-root {\n  color: var(--comms-positive, #0b6a48);\n}\n\n.decreaseText.MuiTypography-root {\n  color: var(--comms-negative, #b9232f);\n}\n\n.dropdownDiv {\n  float: right;\n  /* margin-top: 8px; */\n  /* margin-right: 20px; */\n  display: flex;\n  align-items: center;\n}\n\n/* .MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root{\n  height: 32px !important;\n} */\n\n.monthDropdown {\n  width: auto;\n  height: 28px;\n  flex-shrink: 0;\n  align-items: left;\n  gap: 16px;\n}\n\n.monthDropdown.MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  /* Body 11 Medium */\n  font-family: Poppins;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  /* 127.273% */\n}\n\n.downloadIcon {\n  margin-left: 6px;\n  width: 24px;\n  height: 24px;\n}\n\n.dividerBeforeTicket {\n  /* width: 1060px; */\n  height: 1px;\n  padding-top: 10px;\n}\n\n.ticketDiv {\n  width: 212px;\n  height: 107px;\n  padding: 17px 12px;\n  margin-right: 18px;\n  border-radius: 12px;\n  margin-top: 8px;\n  border: 1px solid #e1e1e1;\n  margin-bottom: 18px;\n}\n\n.ticketSizeText.MuiTypography-root {\n  margin-top: 15px;\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n}\n\n.ticketAmout.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  margin-bottom: 9px;\n}\n\n.ticketCount.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n}\n\n.countBorder {\n  border: 1px solid var(--text-highest, rgba(1, 1, 2, 0.92));\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  padding-left: 4px;\n  margin-right: 9px;\n}\n\n.ticketTransaction.MuiTypography-root {\n  color: rgba(1, 1, 2, 0.6);\n\n  margin-bottom: 4px;\n}\n\n.ticketValue {\n  color: rgba(1, 1, 2, 0.72);\n  font-weight: 700;\n}\n\n/* graph divs */\n\n.graphyDiv {\n  width: 70%;\n  height: 300px;\n}\n\n.paymentDiv {\n  height: 412px;\n  flex-shrink: 0;\n  border-radius: 16px;\n  background: white !important;\n  padding: 16px;\n}\n\n.paymentHeading.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  margin-bottom: 12px;\n}\n\n.payemntDataDiv {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px;\n  height: 26px;\n}\n\n.paymentDivider {\n  width: relative;\n  height: 1px;\n  background: rgba(1, 1, 2, 0.12);\n}\n\n.paymentText.MuiTypography-root {\n  color: #0e0f0f;\n  margin-bottom: 12px;\n}\n\n.paymentLogo {\n  margin-right: 8px;\n  width: 16px;\n  height: 16px;\n}\n\n/* payment dropof */\n\n.paymentOfDiv {\n  width: 100%;\n  margin-top: 40px;\n  display: flex;\n  border-radius: 16px;\n  background: var(--primary-accent-sub-2, #f0f5ff);\n}\n\n.countDiv {\n  width: 50%;\n  padding-right: 20px;\n}\n\n.countHeadingDiv {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.countHeading.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n}\n\n.countTransactionDiv {\n  display: flex;\n  flex-direction: column;\n  float: left;\n  width: 50%;\n  margin-bottom: 16px;\n}\n\n.percentageDiv {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.barColorDiv {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.paddingEight {\n  padding-top: 8px;\n  padding-left: 8px;\n}\n\n.divWithLessOnePercentageWidth {\n  /* color: white; */\n  height: 36px;\n  /* margin-right: 8px; */\n}\n\n.countHeading.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n}\n\n.countAmountHeading.MuiTypography-root {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n}\n\n.totalDiv {\n  width: 50%;\n  padding-left: 20px;\n}\n\n/* failure reasons */\n\n.marginTop20 {\n  margin-top: 20px;\n}\n\n.reasonCodeDistributionMainDiv {\n  display: flex;\n  margin-top: 28px;\n  justify-content: center;\n}\n\n.reasonCodeDistributionDiv {\n  width: 60%;\n  height: 396px;\n}\n\n.reasonUpperDiv {\n  display: flex;\n  height: 96px;\n  padding: 24px 24px 16px 24px;\n  justify-content: space-between;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  gap: 24px;\n  background-color: white;\n}\n\n.reasonLowerDiv {\n  width: 100%;\n  /* display: flex; */\n  padding: 20px 24px;\n  /* justify-content: center;\n  align-items: center; */\n  background-color: white;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n  height: 300px;\n  overflow-y: scroll;\n  max-height: 300px;\n}\n\n.reasonLeftDiv {\n  width: 50%;\n  margin-bottom: 14px;\n\n  display: flex;\n  /* justify-content: end; */\n  padding-right: 50px;\n}\n\n.reasonRightDiv {\n  display: flex;\n  width: 50%;\n  text-align: center;\n  margin-bottom: 14px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.marginTopAndLeft.MuiTypography-root {\n  margin-left: 16px;\n  margin-top: 5px;\n}\n\n.analyticsTableDivInFailure {\n  width: 40%;\n  height: 396px;\n  background-color: white;\n  border-radius: 12px;\n  margin-left: 23px;\n}\n\n.paymentOfAndFailureDiv {\n  width: 100%;\n  /* height: 674px; */\n  margin-top: 32px;\n  padding: 32px;\n  flex-shrink: 0;\n  border-radius: 16px;\n  background: var(--primary-accent-sub-2, #f0f5ff);\n}\n\n.downloadIconPosition {\n  cursor: pointer;\n  float: right;\n}\n\n.failurePaper.MuiPaper-root {\n  border-radius: 16px;\n  /* background: ; */\n  /* width: 673px; */\n  width: 50%;\n  height: 466px;\n  flex-shrink: 0;\n  margin-left: 32px;\n  margin-right: 32px;\n  margin-top: 20px;\n  padding: 24px;\n}\n\n.refreshButton.MuiButtonBase-root.MuiButton-root {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n  text-transform: none;\n  width: 100px;\n  height: 32px;\n  display: flex;\n  justify-content: space-between;\n  border-radius: 4px;\n  border: 1px solid var(--neutral-5, #d9d9d9);\n  background: var(--neutral-1, #fff);\n  padding: 10px;\n  margin-right: 12px;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.refreshButton:hover {\n  border-color: var(--your-hover-color, black) !important;\n}\n\n.custom-dropdown-icon {\n  color: rgba(0, 0, 0, 0.85) !important;\n  /* Set your desired color */\n}\n\n.MuiButtonBase-root.MuiMenuItem-root:hover {\n  background-color: #F3F4F4;\n}\n\n.MuiButtonBase-root.MuiMenuItem-root {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.businessUnit.MuiButtonBase-root.MuiMenuItem-root {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.itemNameStyling {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.businessUnitCheckbox .MuiSvgIcon-root {\n  height: 16px !important;\n  width: 16px !important;\n}\n\n.ellipsisListItem .MuiListItemText-root .MuiTypography-root {\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ellipsisListItemInsurer .MuiListItemText-root .MuiTypography-root {\n  max-width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {\n  /* background-color: #F3F4F4; */\n}\n\n.overview-analytics-root {\n  width: 100%;\n  background: #fff;\n}\n\n.overview-analytics-contnet {\n  display: grid;\n  grid-template-columns: calc(55% - 28px) 45%;\n  column-gap: 24px;\n  row-gap: 28px;\n  margin-top: 28px;\n}\n\n.overview-analytics-contnet>div:first-child {\n  grid-column: 1 / span 2;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
